import type { InboundDocument } from "src/api/interfaces/inbound_document";
import type {
  ColumnDefinition,
  DataTableDefinition,
} from "src/components/DataTable/DataTableDefinition";
import ValidationGroupStatusIndicator from "src/components/Pages/DocumentInbound/Tabs/Validations/DocumentCompliance/DocumentComplianceListing/ValidationGroupStatusIndicator";
import { ValidationGroupField } from "src/constants";
import ValidationUserActions from "src/components/UserActions/ValidationUserActions";
import { MetricAction } from "src/metrics";

const documentComplianceColumnsDefinition: ColumnDefinition[] = [
  {
    label: "aic_doc_page_validations_tab_header_validation_rule",
    property: ValidationGroupField.VALIDATION_GROUP_NAME.valueOf(),
    translateValue: true,
  },
  {
    label: "aic_doc_page_validations_tab_header_description",
    property: ValidationGroupField.DESCRIPTION.valueOf(),
    translateValue: true,
  },
  {
    label: "aic_doc_page_validations_tab_header_status",
    property: ValidationGroupField.VALIDATION_GROUP_STATUS.valueOf(),
    translateValue: true,
    ChildComponent: ValidationGroupStatusIndicator,
    childComponentOnly: true,
  },
  {
    label: "aic_doc_page_validations_tab_header_actions",
    property: ValidationGroupField.VALIDATION_GROUP_NAME.valueOf(),
    translateValue: true,
    childComponentOnly: true,
    ChildComponent: ValidationUserActions,
    childComponentProps: {
      metricAction: MetricAction.VALIDATION_TAB_USER_ACTION,
    },
  },
];

const documentComplianceDataTableDefinition: DataTableDefinition<InboundDocument> =
  {
    columnsDefinition: documentComplianceColumnsDefinition,
  };

export default documentComplianceDataTableDefinition;
